import { DispatchItem } from "./DispatchItem";
import { LocationType } from "./Enums";

export class ScheduleItem {
    scheduleId: number = 0;
    scheduleIdDisplay: string = '';
    locCode: string = '';
    scheduleBeginDate: string = '';
    scheduleEndDate: string = '';
    locationType: LocationType = LocationType.Origin;
    commodityCode: string = '';
    alternateCommodity: string = '';
    customerCode: string = '';
    customerName: string = '';
    locationCode: string = '';
    locationName: string = '';
    locationCity: string = '';
    locationState: string = '';
    deliveryTerm: string = '';
    scheduleType: string = '';
    enteredBy: string = '';
    loadNumber: string = '';
    loadNotes: string = '';
    locationNotes: string = '';
    internalNotes: string = '';

    loads: number = 0;
    dispatchedLoads: number = 0;
    balanceLoads: number = 0;
    unassignedLoads: string = '';
    confirmedLoads: string = '';
    unconfirmedLoads: string = '';

    dispatches: DispatchItem[] = [];
    enteredByEmail: string = '';

    planLoads0: number = 0;
    planLoads1: number = 0;
    planLoads2: number = 0;
    planLoads3: number = 0;
    planLoads4: number = 0;
    planLoads5: number = 0;
    planLoads6: number = 0;

    dailyLoads: number[] = [];

    dispatchesCount: number = 0;
}
